import { z } from "zod";

export const AppointmentSchema = z
  .object({
    clientId: z.string().cuid(),
    assignedToId: z.string().cuid().nullable().optional(),
    serviceItemId: z.string().cuid().nullable().optional(),
    resourceId: z.string().cuid().nullable().optional(),
    startsAt: z.coerce.date(),
    duration: z.number().int().min(15).max(480),
    price: z.number().min(0),
    type: z.string().optional(),
    isRecurring: z.boolean().default(false),
    recurrence: z.enum(["weekly", "biweekly", "custom"]).optional(),
    /** Intervalle en semaines si recurrence = custom. */
    recurrenceIntervalWeeks: z.number().int().min(1).max(12).optional(),
    /** Nombre de séances à créer (y compris la première) lorsque la récurrence est activée. */
    recurrenceCount: z.number().int().min(2).max(52).optional(),
  })
  .superRefine((data, ctx) => {
    if (data.isRecurring) {
      if (!data.recurrence) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Fréquence de récurrence requise",
          path: ["recurrence"],
        });
      }
      if (data.recurrence === "custom") {
        if (
          typeof data.recurrenceIntervalWeeks !== "number" ||
          Number.isNaN(data.recurrenceIntervalWeeks)
        ) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Intervalle de récurrence requis",
            path: ["recurrenceIntervalWeeks"],
          });
        }
      } else if (data.recurrenceIntervalWeeks != null) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message:
            "recurrenceIntervalWeeks uniquement si la récurrence personnalisée est activée",
          path: ["recurrenceIntervalWeeks"],
        });
      }
    } else if (data.recurrenceIntervalWeeks != null) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message:
          "recurrenceIntervalWeeks uniquement si la récurrence est activée",
        path: ["recurrenceIntervalWeeks"],
      });
    } else if (data.recurrenceCount != null) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "recurrenceCount uniquement si la récurrence est activée",
        path: ["recurrenceCount"],
      });
    }
  });

export type AppointmentDto = z.infer<typeof AppointmentSchema>;
